import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34220962"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-default-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "modal-title break-word" }, "Warning", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content break-word" }, "Your membership has expired and your last payment attempt failed. To regain access to everything you love, please update your payment method on the billing page.", -1))
const _hoisted_4 = { class: "controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["AppModal"], {
    "is-open": $props.isOpen,
    onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.close()))
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "button default primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onOk()))
          }, "Go To Billing")
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}